import { useEffect, useState } from "react"
import { Icon } from "../trust-center/ui/primitives"
import AuthSteps from "./AuthSteps"

export default function TrustLoginModal({
    isOpen,
    onClose,
    onAuthSuccess,
}) {
    const [authStep, setAuthStep] = useState("form")

    useEffect(() => {
        if (!isOpen) return
        const k = (e) => e.key === "Escape" && onClose()
        window.addEventListener("keydown", k)
        return () => window.removeEventListener("keydown", k)
    }, [isOpen, onClose])

    if (!isOpen) return null

    const handleAuthenticated = (user) => {
        onAuthSuccess?.(user)
        onClose()
    }

    return (
        <div className="overlay" onClick={onClose}>
            <div className={`modal${authStep === "register" ? " modal--register" : ""}`} onClick={(e) => e.stopPropagation()}>
                <div className="modal__head">
                    <span className="modal__ico"><Icon name="padlock-locked" size={22} /></span>
                    <div>
                        <h3>Sign in to the Trust Center</h3>
                    </div>
                    <button className="modal__x" onClick={onClose} aria-label="Close"><Icon name="close" size={18} /></button>
                </div>

                <div className="modal__body">
                    <AuthSteps onAuthenticated={handleAuthenticated} onStepChange={setAuthStep} />
                </div>
            </div>
        </div>
    )
}
